import * as React from 'react';
import { Button, UIHeading1, UIText1 } from '@cian/ui-kit';

import * as styles from './styles.css';

interface IEmptyListProps {
  onClick(): void;
}

export const EmptyList = ({ onClick }: IEmptyListProps): React.JSX.Element => {
  return (
    <div className={styles['container']}>
      <div className={styles['title']}>
        <UIHeading1>Ничего не найдено</UIHeading1>
      </div>
      <div className={styles['subtitle']}>
        <UIText1>Попробуйте выставить другие настройки</UIText1>
      </div>
      <div className={styles['button']}>
        <Button fullWidth={true} size="XS" onClick={onClick}>
          Сбросить
        </Button>
      </div>
    </div>
  );
};
